// import React, { useState } from 'react';
// import './BookSession.css';

// const BookSession = () => {
//   const [formData, setFormData] = useState({
//     name: '',
//     email: '',
//     occupation: '',
//     organization: '',
//     purpose: '',
//     contact_mode: '',
//     phone_number: '',
//     remarks: ''
//   });
  
//   const [emailError, setEmailError] = useState('');
//   const [isSubmitted, setIsSubmitted] = useState(false);
//   const [errorMessage, setErrorMessage] = useState('');
//   const [isLoading, setIsLoading] = useState(false);

//   // Email validation regex (modern standard, handles most valid email formats)
//   const emailRegex = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;

//   const handleInputChange = (e) => {
//     const { name, value } = e.target;
//     setFormData({ ...formData, [name]: value });

//     if (name === 'email') {
//       validateEmail(value);
//     }
//   };

//   const validateEmail = (email) => {
//     if (!email) {
//       setEmailError('Email is required');
//       return false;
//     }
//     if (!emailRegex.test(email)) {
//       setEmailError('Please enter a valid email address');
//       return false;
//     }
//     if (email.length > 254) {
//       setEmailError('Email address is too long');
//       return false;
//     }
//     setEmailError('');
//     return true;
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
    
//     // Validate email before submission
//     const isEmailValid = validateEmail(formData.email);
    
//     if (isEmailValid) {
//       setIsLoading(true);
//       setErrorMessage('');
//       try {
//         const response = await fetch('https://aikyam-hkfac5a0c6h5bqhe.centralindia-01.azurewebsites.net/admin/adminMeeting', {
//           method: 'POST',
//           headers: {
//             'Content-Type': 'application/json',
//           },
//           body: JSON.stringify(formData),
//         });

//         if (response.ok) {
//           setIsSubmitted(true);
//           setErrorMessage('');
//           // Reset form after successful submission
//           setFormData({
//             fullName: '',
//             email: '',
//             occupation: '',
//             organization: '',
//             purpose: '',
//             contactMode: 'Phone Call',
//             phoneNumber: '',
//             remarks: ''
//           });
//           setTimeout(() => setIsSubmitted(false), 3000); // Hide success message after 3 seconds
//         } else {
//           const errorData = await response.json().catch(() => ({}));
//           throw new Error(errorData.message || `Server responded with status ${response.status}`);
//         }
//       } catch (error) {
//         setErrorMessage(error.message || 'An error occurred while submitting the form. Please try again.');
//         console.error('Submission error:', error, 'Response:', await error.response?.text());
//       } finally {
//         setIsLoading(false);
//       }
//     }
//   };

//   return (
//     <div className="book-session-wrapper">
//       <div className="ellipse ellipse-left"></div>
//       <div className="ellipse ellipse-right"></div>

//       <div className="book-session-container">
//         <h2 className="book-session-title">Book a Meeting with our Team</h2>
//         {isSubmitted && (
//           <div className="success-message">
//             Form submitted successfully!
//           </div>
//         )}
//         {errorMessage && (
//           <div className="error-message">
//             {errorMessage}
//           </div>
//         )}
//         <form onSubmit={handleSubmit}>
//           <div className="form-grid">
//             <div className="form-group">
//               <label>Full Name*</label>
//               <input
//                 type="text"
//                 name="fullName"
//                 value={formData.fullName}
//                 onChange={handleInputChange}
//                 placeholder="Enter your name."
//                 required
//                 disabled={isLoading}
//               />
//             </div>
//             <div className="form-group">
//               <label>Email ID*</label>
//               <input
//                 type="email"
//                 name="email"
//                 value={formData.email}
//                 onChange={handleInputChange}
//                 placeholder="Enter your Email id."
//                 required
//                 className={emailError ? 'error' : ''}
//                 disabled={isLoading}
//               />
//               {emailError && <span className="error-message">{emailError}</span>}
//             </div>
//             <div className="form-group">
//               <label>Occupation*</label>
//               <input
//                 type="text"
//                 name="occupation"
//                 value={formData.occupation}
//                 onChange={handleInputChange}
//                 placeholder="Enter your Occupation."
//                 required
//                 disabled={isLoading}
//               />
//             </div>
//             <div className="form-group">
//               <label>Organization*</label>
//               <input
//                 type="text"
//                 name="organization"
//                 value={formData.organization}
//                 onChange={handleInputChange}
//                 placeholder="Enter your Organization"
//                 required
//                 disabled={isLoading}
//               />
//             </div>
//             <div className="form-group purpose">
//               <label>Purpose</label>
//               <select
//                 name="purpose"
//                 value={formData.purpose}
//                 onChange={handleInputChange}
//                 disabled={isLoading}
//               >
//                 <option value="" disabled>
//                   -- Choose a value --
//                 </option>
//                 <option value="timing">Enquiry about Timing Gate Systems</option>
//                 <option value="nutrition">Enquiry about Nutrition Programs</option>
//                 <option value="assessment">Enquiry about Sports Assessment</option>
//                 <option value="training">Enquiry About Athlete Training</option>
//                 <option value="others">Others</option>
//               </select>
//             </div>
//             <div className="form-group contact-mode">
//               <label>Contact Mode</label>
//               <select
//                 name="contactMode"
//                 value={formData.contactMode}
//                 onChange={handleInputChange}
//                 disabled={isLoading}
//               >
//                 <option value="Phone Call">Phone Call</option>
//                 <option value="WhatsApp Message">WhatsApp Message</option>
//                 <option value="Quick Zoom Call">Quick Zoom Call</option>
//               </select>
//             </div>
//             <div className="form-group">
//               <label>Phone Number*</label>
//               <input
//                 type="tel"
//                 name="phoneNumber"
//                 value={formData.phoneNumber}
//                 onChange={handleInputChange}
//                 placeholder="Enter your Phone No."
//                 required
//                 disabled={isLoading}
//               />
//             </div>
//             <div className="form-group remarks">
//               <label>Remarks</label>
//               <textarea
//                 name="remarks"
//                 value={formData.remarks}
//                 onChange={handleInputChange}
//                 placeholder="Give Remarks."
//                 disabled={isLoading}
//               />
//             </div>
//           </div>
//           <button type="submit" className="submit-btn" disabled={isLoading}>
//             {isLoading ? 'Submitting...' : 'Submit'}
//           </button>
//         </form>
//       </div>
//     </div>
//   );
// };

// export default BookSession;

import React, { useState } from 'react';
import axios from 'axios';
import './BookSession.css';
import { Helmet } from 'react-helmet-async';

const BookSession = () => {
  const [formData, setFormData] = useState({
    fullName: '',
    email: '',
    occupation: '',
    organization: '',
    purpose: '',
    contactMode: 'Phone Call',
    phoneNumber: '',
    remarks: ''
  });
  
  const [emailError, setEmailError] = useState('');
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  // Email validation regex (modern standard, handles most valid email formats)
  const emailRegex = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });

    if (name === 'email') {
      validateEmail(value);
    }
  };

  const validateEmail = (email) => {
    if (!email) {
      setEmailError('Email is required');
      return false;
    }
    if (!emailRegex.test(email)) {
      setEmailError('Please enter a valid email address');
      return false;
    }
    if (email.length > 254) {
      setEmailError('Email address is too long');
      return false;
    }
    setEmailError('');
    return true;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    // Validate email before submission
    const isEmailValid = validateEmail(formData.email);
    
    if (isEmailValid) {
      setIsLoading(true);
      setErrorMessage('');

      // Transform formData to match database column names (snake_case)
      const payload = {
        name: formData.fullName,
        email: formData.email,
        occupation: formData.occupation,
        organization: formData.organization,
        purpose: formData.purpose,
        contact_mode: formData.contactMode,
        phone_number: formData.phoneNumber,
        remarks: formData.remarks
      };

      try {
        const response = await axios.post(
          'https://aikyam-server-supabaseoff.onrender.com/admin/adminMeeting',
          payload,
          {
            headers: {
              'Content-Type': 'application/json',
            },
          }
        );

        if (response.status === 200 || response.status === 201) {
          setIsSubmitted(true);
          setErrorMessage('');
          // Reset form after successful submission
          setFormData({
            fullName: '',
            email: '',
            occupation: '',
            organization: '',
            purpose: '',
            contactMode: 'Phone Call',
            phoneNumber: '',
            remarks: ''
          });
          setTimeout(() => setIsSubmitted(false), 3000); // Hide success message after 3 seconds
        } else {
          throw new Error(`Unexpected response status: ${response.status}`);
        }
      } catch (error) {
        const errorMsg = error.response?.data?.message || error.message || 'An error occurred while submitting the form. Please try again.';
        setErrorMessage(errorMsg);
        console.error('Submission error:', error, 'Response:', error.response?.data);
      } finally {
        setIsLoading(false);
      }
    }
  };

  return (
     <>
      <Helmet>
        <title>Book a Session | Aikyam Sports</title>
        <meta
          name="description"
          content="Book a meeting with the Aikyam Sports team for timing gate systems, nutrition programs, sports assessment, athlete training, or physiotherapy enquiries."
        />
        <link rel="canonical" href="https://aikyamsports.com/booking" />

        {/* Open Graph */}
        <meta property="og:title" content="Book a Session | Aikyam Sports" />
        <meta
          property="og:description"
          content="Schedule a meeting with Aikyam Sports for timing gates, nutrition, athlete training, and physiotherapy enquiries."
        />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://aikyamsports.com/booking" />
        <meta property="og:image" content="https://aikyamsports.com/logo11.png" />

        {/* Twitter */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Book a Session | Aikyam Sports" />
        <meta
          name="twitter:description"
          content="Schedule a meeting with Aikyam Sports for timing gates, nutrition, athlete training, and physiotherapy enquiries."
        />
        <meta name="twitter:image" content="https://aikyamsports.com/logo11.png" />
      </Helmet>
    <div className="book-session-wrapper">
      <div className="ellipse ellipse-left"></div>
      <div className="ellipse ellipse-right"></div>

      <div className="book-session-container">
        <h2 className="book-session-title">Book a Meeting with our Team</h2>
        {isSubmitted && (
          <div className="success-message">
            Form submitted successfully!
          </div>
        )}
        {errorMessage && (
          <div className="error-message">
            {errorMessage}
          </div>
        )}
        <form onSubmit={handleSubmit}>
          <div className="form-grid">
            <div className="form-group">
              <label>Full Name*</label>
              <input
                type="text"
                name="fullName"
                value={formData.fullName}
                onChange={handleInputChange}
                placeholder="Enter your name."
                required
                disabled={isLoading}
              />
            </div>
            <div className="form-group">
              <label>Email ID*</label>
              <input
                type="email"
                name="email"
                value={formData.email}
                onChange={handleInputChange}
                placeholder="Enter your Email id."
                required
                className={emailError ? 'error' : ''}
                disabled={isLoading}
              />
              {emailError && <span className="error-message">{emailError}</span>}
            </div>
            <div className="form-group">
              <label>Occupation*</label>
              <input
                type="text"
                name="occupation"
                value={formData.occupation}
                onChange={handleInputChange}
                placeholder="Enter your Occupation."
                required
                disabled={isLoading}
              />
            </div>
            <div className="form-group">
              <label>Organization*</label>
              <input
                type="text"
                name="organization"
                value={formData.organization}
                onChange={handleInputChange}
                placeholder="Enter your Organization"
                required
                disabled={isLoading}
              />
            </div>
            <div className="form-group purpose">
              <label>Purpose</label>
              <select
                name="purpose"
                value={formData.purpose}
                onChange={handleInputChange}
                disabled={isLoading}
              >
                <option value="" disabled>
                  -- Choose a value --
                </option>
                <option value="timing">Enquiry about Timing Gate Systems</option>
                <option value="nutrition">Enquiry about Nutrition Programs</option>
                <option value="assessment">Enquiry about Sports Assessment</option>
                <option value="training">Enquiry About Athlete Training</option>
               <option value="treatment">Enquiry  About Physiotherapy Program's </option>

                <option value="others">Others</option>
              </select>
            </div>
            <div className="form-group contact-mode">
              <label>Contact Mode</label>
              <select
                name="contactMode"
                value={formData.contactMode}
                onChange={handleInputChange}
                disabled={isLoading}
              >
                <option value="Phone Call">Phone Call</option>
                <option value="WhatsApp Message">WhatsApp Message</option>
                <option value="Quick Zoom Call">Quick Zoom Call</option>
              </select>
            </div>
            <div className="form-group">
              <label>Phone Number*</label>
              <input
                type="tel"
                name="phoneNumber"
                value={formData.phoneNumber}
                onChange={handleInputChange}
                placeholder="Enter your Phone No."
                required
                disabled={isLoading}
              />
            </div>
            <div className="form-group remarks">
              <label>Remarks</label>
              <textarea
                name="remarks"
                value={formData.remarks}
                onChange={handleInputChange}
                placeholder="Give Remarks."
                disabled={isLoading}
              />
            </div>
          </div>
          <button type="submit" className="submit-btn" disabled={isLoading}>
            {isLoading ? 'Submitting...' : 'Submit'}
          </button>
        </form>
      </div>
    </div>
    </>
  );
};

export default BookSession;